// extracted by mini-css-extract-plugin
module.exports = {"statsRow":"_FinancialStats_statsRow__Iz5d0","rowHead":"_FinancialStats_rowHead__11LGC","box":"_FinancialStats_box__2ekUG"};